import { useState, useRef } from "react";
import { Box, Text } from "@chakra-ui/react";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailTagsInput = ({ values, onChange, placeholder, borderColor = "gray.200" }) => {
    const [inputValue, setInputValue] = useState("");
    const [inputError, setInputError] = useState(false);
    const inputRef = useRef(null);

    const commit = () => {
        const trimmed = inputValue.trim();
        if (!trimmed) { setInputError(false); return; }
        if (!EMAIL_REGEX.test(trimmed)) { setInputError(true); return; }
        const lower = trimmed.toLowerCase();
        if (values.some((v) => v.toLowerCase() === lower)) {
            setInputValue(""); setInputError(false); return;
        }
        onChange([...values, trimmed]);
        setInputValue(""); setInputError(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") { e.preventDefault(); commit(); }
    };

    return (
        <Box w={"full"}>
            <Box
                bg="white"
                border="1px solid"
                borderColor={borderColor}
                borderRadius="l2"
                p={2}
                display="flex"
                flexWrap="wrap"
                gap={1.5}
                alignItems="center"
                cursor="text"
                onClick={() => inputRef.current?.focus()}
                _focusWithin={{ borderColor: "purple.400" }}
                minH="10"
                w={"full"}
            >
                {values.map((email, i) => (
                    <Box
                        key={i}
                        display="inline-flex"
                        alignItems="center"
                        gap={1}
                        px={2}
                        py={0.5}
                        bg="purple.50"
                        color="purple.700"
                        borderRadius={4}
                        fontSize="xs"
                    >
                        <Text>{email}</Text>
                        <Box
                            as="button"
                            type="button"
                            onClick={(e) => { e.stopPropagation(); onChange(values.filter((_, j) => j !== i)); }}
                            lineHeight={1}
                            color="purple.500"
                            _hover={{ color: "purple.800" }}
                            fontSize="sm"
                        >
                            ×
                        </Box>
                    </Box>
                ))}
                <Box
                    as="input"
                    ref={inputRef}
                    value={inputValue}
                    onChange={(e) => { setInputValue(e.target.value); if (inputError) setInputError(false); }}
                    onKeyDown={handleKeyDown}
                    onBlur={commit}
                    placeholder={values.length === 0 ? placeholder : undefined}
                    bg="transparent"
                    color="gray.900"
                    fontSize="sm"
                    border="none"
                    outline="none"
                    flex="1"
                    minW="160px"
                    style={{ color: "#17151F", background: "transparent" }}
                />
            </Box>
            {inputError && (
                <Text fontSize="xs" color="red.600" mt={1}>Wprowadź poprawny adres e-mail.</Text>
            )}
        </Box>
    );
};

export default EmailTagsInput;
